import { render, staticRenderFns } from "./ShippingDetails.vue?vue&type=template&id=300f25e2&scoped=true"
import script from "./ShippingDetails.vue?vue&type=script&lang=js"
export * from "./ShippingDetails.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ShippingDetails.vue?vue&type=style&index=0&id=300f25e2&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "300f25e2",
  "76522a73"
  
)

export default component.exports